export const RQ_GET_ALL_USER_LIST_API = {
  url: 'api/order/<%= id %>/lookup',
  method: 'GET',
  auth: true,
};

export const RQ_GET_USER_ORDERS_LIST_API = {
  url: 'api/order/lookup/all/user/<%= id %>',
  method: 'GET',
  auth: true,
};

export const RQ_DELETE_USER_API = {
  url: 'api/user/delete/<%= id %>',
  method: 'DELETE', 
  auth: true,
};
